module.exports = __webpack_public_path__ + "img/90sn_pack.e4fc8be0.png";